import ApiResourceManager from '../ApiResourceManager';

/**
 * Partner self-service billing — no on-behalf header, the backend pins
 * partner admins to their own provider.
 */
export default class PartnerBillingManager extends ApiResourceManager {
  createCheckoutSession = (data) =>
    this.request({
      method: 'POST',
      url: '/partner-billing/payment-options/checkout-session',
      data,
    });

  paymentOptions = () =>
    this.request({
      method: 'GET',
      url: '/partner-billing/payment-options',
    });

  deletePaymentOption = (paymentOptionId) =>
    this.request({
      method: 'DELETE',
      url: `/partner-billing/payment-options/${paymentOptionId}`,
    });

  invoices = (params = {}) =>
    this.request({
      method: 'GET',
      url: '/partner-billing/invoices',
      params,
    });

  invoice = (invoiceId) =>
    this.request({
      method: 'GET',
      url: `/partner-billing/invoices/${invoiceId}`,
    });

  companyItems = (invoiceId, companyId) =>
    this.request({
      method: 'GET',
      url: `/partner-billing/invoices/${invoiceId}/companies/${companyId}`,
    });

  partnerLevelItems = (invoiceId) =>
    this.request({
      method: 'GET',
      url: `/partner-billing/invoices/${invoiceId}/partner-level`,
    });

  itemEntries = (itemId, page = 1) =>
    this.request({
      method: 'GET',
      url: `/partner-billing/invoice-items/${itemId}/entries`,
      params: { page },
    });

  export = (invoiceId, format) =>
    this.request({
      method: 'GET',
      url: `/partner-billing/invoices/${invoiceId}/export`,
      params: { format },
      responseType: 'blob',
    });

  /** Platform custody: the payout account's KYC state (null for own-keys partners). */
  payoutAccount = () =>
    this.request({
      method: 'GET',
      url: '/partner-billing/payout-account',
    });

  createPayoutOnboardingLink = (data) =>
    this.request({
      method: 'POST',
      url: '/partner-billing/payout-account/onboarding-link',
      data,
    });

  /** Sent straight to the payout account; only a masked label is kept. */
  updatePayoutBankAccount = (data) =>
    this.request({
      method: 'PUT',
      url: '/partner-billing/payout-account/bank-account',
      data,
    });

  settlements = (params = {}) =>
    this.request({
      method: 'GET',
      url: '/partner-billing/settlements',
      params,
    });
}
